import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/FAQAccordion.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SmartSearch"] */ "/app/src/components/v2/home/SmartSearch.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VideoStrip"] */ "/app/src/components/v2/home/VideoStrip.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PageVideo"] */ "/app/src/components/v2/PageVideo.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ScrollRow"] */ "/app/src/components/v2/ScrollRow.tsx");
